import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { BaseBorrowerLoanSubmissionStore } from '../stores/baseBorrowerLoanSubmissionStore';

export const useBorrowerLoanSubmissionStore = () =>
  useContext<{
    borrowerLoanSubmissionStore: BaseBorrowerLoanSubmissionStore;
  }>(StoreContext);
